module.exports = __webpack_public_path__ + "static/media/speed_read_footer.408c4c64.png";